import api from './api';
import { JwtService, SessionTokens } from './jwtService';

let pendingRefresh: Promise<string | null> | null = null;

const requestRefresh = async (refreshToken: string): Promise<string | null> => {
  try {
    const response = await api.post<SessionTokens>('/refresh', { refresh_token: refreshToken });
    JwtService.saveSession(response.data);
    return response.data.access_token;
  } catch {
    JwtService.clear();
    return null;
  } finally {
    pendingRefresh = null;
  }
};

// Renueva el access token con el refresh token de la pestaña. Las llamadas concurrentes
// (loader del router y AuthProvider al recargar) comparten una sola petición a /refresh.
export const refreshSession = (): Promise<string | null> => {
  if (pendingRefresh) {
    return pendingRefresh;
  }

  const refreshToken = JwtService.getRefreshToken();
  if (!refreshToken) {
    return Promise.resolve(null);
  }

  pendingRefresh = requestRefresh(refreshToken);
  return pendingRefresh;
};

// Devuelve el access token en memoria o, tras una recarga, lo recupera vía /refresh.
export const ensureSession = (): Promise<string | null> => {
  const token = JwtService.getJwt();
  return token ? Promise.resolve(token) : refreshSession();
};
